module.exports = __webpack_public_path__ + "media/choujiangbg.0ecea466.mp3";